import { useEffect, useState, useCallback } from "react";
import Collection_dropdown2 from "../dropdown/collection_dropdown2";
import { getAllSubCampaign } from "../../services/campaign";
import { errorToast } from "../../utils/toast";
import { getCategory } from "../../services/vetting";
import Link from "next/link";
import Image from "next/image";
export const baseURL = `${process.env.NEXT_PUBLIC_BASE_URL}/`;

function ViewSubCampaigns({ id }) {
  const [campaign, setCampaign] = useState([]);
  const [filteredCampaigns, setFilteredCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState({
    subCampaign: [
      {
        id: 0,
        text: "All",
        image: "/images/avatars/collection_ava_1.png",
      },
    ],
    impactCategory: [
      {
        id: 0,
        text: "All",
        image: "/images/avatars/collection_ava_1.png",
      },
    ],
  });
  const [filterValue, setFilterValue] = useState({
    subCampaign: "",
    impactCategory: "",
  });

  const getFilter = useCallback(async () => {
    try {
      const campaignCategory = await getCategory("CAMPAIGN");
      const subCampaign = await getAllSubCampaign(id);

      setFilter((prevFilter) => ({
        ...prevFilter,
        subCampaign: [
          {
            id: 0,
            text: "All",
            image: "/images/avatars/collection_ava_1.png",
          },
          ...(subCampaign?.subCampaigns.map((item, i) => ({
            id: i + 1,
            text: item.overview.campaignName,
            image: "/images/avatars/collection_ava_1.png",
          })) || []),
        ],
        impactCategory: [
          {
            id: 0,
            text: "All",
            image: "/images/avatars/collection_ava_1.png",
          },
          ...(campaignCategory?.categoriesList.map((item, i) => ({
            id: i + 1,
            text: item,
            image: "/images/avatars/collection_ava_1.png",
          })) || []),
        ],
      }));
    } catch (error) {
      console.error("Error loading filters:", error);
    }
  }, [id]);

  useEffect(() => {
    console.log("ViewSubCampaigns: Starting data fetch for campaign ID:", id);
    setLoading(true);
    getAllSubCampaign(id)
      .then(async (res) => {
        console.log("ViewSubCampaigns: API response:", res);
        setCampaign(res.subCampaigns || []);
        console.log("ViewSubCampaigns: Set campaigns:", res.subCampaigns || []);
        setLoading(false);
        getFilter();
      })
      .catch((err) => {
        console.error("ViewSubCampaigns: API error:", err);
        setLoading(false);
        errorToast(err);
      });
  }, [id, getFilter]);

  useEffect(() => {
    console.log(
      "ViewSubCampaigns: Filtering campaigns. Campaign data:",
      campaign,
    );
    console.log("ViewSubCampaigns: Filter values:", filterValue);

    const { subCampaign, impactCategory } = filterValue;

    let filteredCampaigns = campaign;

    // Filter by sub campaign (skip if "All" is selected)
    if (subCampaign && subCampaign.text !== "All") {
      filteredCampaigns = filteredCampaigns.filter(
        (item) =>
          item.overview?.campaignName?.toLowerCase() ===
          subCampaign.text.toLowerCase(),
      );
    }

    // Filter by impact category (skip if "All" is selected)
    if (impactCategory && impactCategory.text !== "All") {
      filteredCampaigns = filteredCampaigns.filter(
        (item) =>
          item.impact?.category?.toLowerCase() ===
          impactCategory.text.toLowerCase(),
      );
    }

    console.log(
      "ViewSubCampaigns: Filtered campaigns result:",
      filteredCampaigns,
    );
    setFilteredCampaigns(filteredCampaigns);
  }, [campaign, filterValue]);

  return (
    <>
      <div className="flex flex-col md:flex-row">
        <div className="w-full md:w-1/3 p-4">
          <div className="relative">
            <div>
              <label className="ml-1 font-display text-jacarta-700 mb-2 block dark:text-white">
                Browse By Sub Campaign
              </label>
            </div>

            {/* dropdown */}
            <div className="dropdown my-1 cursor-pointer">
              <Collection_dropdown2
                data={filter.subCampaign}
                collection={true}
                setFilterValue={(value) =>
                  setFilterValue((prev) => ({ ...prev, subCampaign: value }))
                }
                filterValue={filterValue.subCampaign}
              />
            </div>
          </div>
        </div>
        <div className="w-full md:w-1/3 p-4">
          <div className="relative">
            <div>
              <label className="ml-1 font-display text-jacarta-700 mb-2 block dark:text-white">
                Browse by Impact Category
              </label>
            </div>

            {/* dropdown */}
            <div className="dropdown my-1 cursor-pointer">
              <Collection_dropdown2
                data={filter.impactCategory}
                collection={true}
                setFilterValue={(value) =>
                  setFilterValue((prev) => ({ ...prev, impactCategory: value }))
                }
                filterValue={filterValue.impactCategory}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-[1.875rem] md:grid-cols-2 lg:grid-cols-4">
        {loading ? (
          <div className="col-span-full flex justify-center items-center py-8">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-accent"></div>
            <p className="ml-4 text-jacarta-700 dark:text-white">
              Loading sub campaigns...
            </p>
          </div>
        ) : filteredCampaigns.length === 0 ? (
          <div className="col-span-full text-center py-8">
            <div className="flex flex-col items-center space-y-4">
              <svg
                className="mx-auto h-16 w-16 text-jacarta-400 dark:text-jacarta-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                />
              </svg>
              <div>
                <p className="text-jacarta-700 dark:text-white font-semibold mb-2">
                  No Sub Campaigns Found
                </p>
                <p className="text-jacarta-500 dark:text-jacarta-400 text-sm">
                  This campaign doesn't have any sub-campaigns associated with
                  it yet.
                </p>
              </div>
            </div>
          </div>
        ) : (
          filteredCampaigns?.map(({ overview, _id }) => {
            return (
              <article key={_id}>
                <div className="dark:bg-jacarta-700 dark:border-jacarta-700 border-jacarta-100 rounded-2.5xl block border bg-white p-[1.1875rem] transition-shadow hover:shadow-lg">
                  <figure className="relative">
                    <Link href={`/campaign/${_id}`}>
                      <Image
                        width={230}
                        height={230}
                        src={(() => {
                          const imageUrl =
                            overview?.bannerImageUrl?.[0] ||
                            overview?.bannerImageUrl;
                          if (!imageUrl)
                            return "/images/placeholder-banner.jpg";

                          // If it's already an absolute URL, use as is
                          if (
                            imageUrl.startsWith("http://") ||
                            imageUrl.startsWith("https://")
                          ) {
                            return imageUrl;
                          }

                          // If it's a relative path without leading slash, add backend URL
                          if (!imageUrl.startsWith("/")) {
                            return `${process.env.NEXT_PUBLIC_BASE_URL || "http://localhost:5000"}/${imageUrl}`;
                          }

                          // If it starts with slash but isn't absolute, add backend URL
                          return `${process.env.NEXT_PUBLIC_BASE_URL || "http://localhost:5000"}${imageUrl}`;
                        })()}
                        alt={overview?.campaignName || "Campaign"}
                        className="w-full h-[230px] rounded-[0.625rem] object-cover"
                        onError={(e) => {
                          e.currentTarget.src =
                            "/images/placeholder-banner.jpg";
                        }}
                      />
                    </Link>
                  </figure>
                  <Link
                    className="font-display hover:text-accent dark:hover:text-accent text-jacarta-700 mt-4 block text-base dark:text-white"
                    href={`/campaign/${_id}`}
                  >
                    {overview?.campaignName}
                  </Link>
                  <div className="mt-2 flex items-center justify-between text-sm font-medium tracking-tight">
                    <div className="flex flex-wrap items-center">
                      {overview?.description?.slice(0, 150)}...
                    </div>
                  </div>
                </div>
              </article>
            );
          })
        )}
      </div>
    </>
  );
}

export default ViewSubCampaigns;
